import React from 'react';
import { Provider } from '../global_context';
import { renderToDomFactory } from './render_to_dom_factory';
import { mapStoresToState } from './map_stores_to_state';

export const onUpdateFactory = (stores, options, container, render, globals) => {
    const renderToDom = renderToDomFactory(container);

    return () => renderToDom(
        <Provider value={globals}>
            {
                render(
                    mapStoresToState(stores),
                    options
                )
            }
        </Provider>
    );
};
